import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";

export default function EmailRoutingHero() {
  return (
    <div className="relative w-full max-w-xl mx-auto" data-testid="hero-routing-visual">
      <div className="absolute -inset-8 bg-[radial-gradient(ellipse_at_center,rgba(242,105,83,0.10),transparent_70%)] pointer-events-none" />

      <div className="relative grid grid-cols-3 items-center gap-3">
        {/* Sender */}
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-4 shadow-sm">
          <div className="flex items-center gap-2 mb-2">
            <div className="h-7 w-7 rounded-full bg-slate-100 grid place-items-center text-[10px] font-bold text-slate-500">JD</div>
            <span className="text-xs text-slate-500">From</span>
          </div>
          <div className="text-xs font-medium text-[#0F172A] truncate">jane@customer.com</div>
          <div className="text-[10px] text-slate-400 mt-1">"Hi, do you take orders?"</div>
        </div>

        {/* oly Inbox routing */}
        <div className="relative flex flex-col items-center">
          <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F26953] to-transparent animate-route-pulse" />
          <div className="relative z-10 rounded-2xl bg-[#0F172A] text-white p-3 shadow-lg">
            <div className="flex items-center gap-1.5">
              <span className="h-6 w-6 rounded-md bg-[#F26953] grid place-items-center">
                <Mail className="h-3.5 w-3.5"/>
              </span>
              <span className="font-[Outfit] font-bold text-xs">oly Inbox</span>
            </div>
            <div className="mt-2 text-[10px] text-slate-300 mono">hello@yourbiz.com</div>
            <div className="mt-1 inline-flex items-center gap-1 text-[10px] text-emerald-400">
              <CheckCircle2 className="h-3 w-3"/> forwarding
            </div>
          </div>
        </div>

        {/* Receiver */}
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-4 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-bold text-slate-500">Your Inbox</span>
            <ArrowRight className="h-3 w-3 text-[#F26953]"/>
          </div>
          <div className="text-xs font-medium text-[#0F172A] truncate">you@yourmail.com</div>
          <div className="mt-1 text-[10px] text-slate-400">"Hi, do you take orders?"</div>
          <div className="mt-2 inline-flex items-center text-[10px] font-semibold text-[#F26953] bg-[#FEE7E1] rounded px-1.5 py-0.5">to: hello@yourbiz.com</div>
        </div>
      </div>

      {/* Floating envelope */}
      <div className="absolute top-1/2 -mt-3 left-[18%] pointer-events-none">
        <div className="animate-envelope">
          <div className="rounded-md bg-[#F26953] text-white p-1.5 shadow-md">
            <Mail className="h-3 w-3"/>
          </div>
        </div>
      </div>

      {/* Underline labels */}
      <div className="grid grid-cols-3 gap-3 mt-4 text-center">
        <span className="text-[10px] font-semibold tracking-wider uppercase text-slate-400">Customer</span>
        <span className="text-[10px] font-semibold tracking-wider uppercase text-[#F26953]">We route</span>
        <span className="text-[10px] font-semibold tracking-wider uppercase text-slate-400">Your Inbox</span>
      </div>
    </div>
  );
}
